<template>
  <div class="menu_bottom">
    <div class="menu_bottom_container">
      <div class="login_user_name">
        <label class="login_user_name_label">{{ accountName }}</label>
      </div>
      <div class="menu_bottom_icons">
        <img
          :src="option"
          class="option"
          @click="showOptionWindow"
          v-if="!browsingAccountFlg"
        />
        <img :src="escape" class="escape" @click="showExitModalWindow = true" />
      </div>
      <div class="modal_window" v-if="showExitModalWindow">
        <exitModalWindow :question="logoutWord" @close="close" @ok="logout">
        </exitModalWindow>
      </div>
      <div class="modal_window" v-if="showOptionModalWindow">
        <optionModalWindow :question="logoutWord" @close="close">
        </optionModalWindow>
      </div>
      <div class="modal_window" v-if="showCompleteModal">
        <finishModalWindow :question="completeWord" @close="close">
        </finishModalWindow>
      </div>
      <div class="modal_window" v-if="showfailedModal">
        <finishModalWindow :question="failedWord" @close="close">
        </finishModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import optionModalWindow from './modalWindow/optionModalWindow.vue'
import exitModalWindow from './modalWindow/confirmModalWindow.vue'
import finishModalWindow from './modalWindow/finishModalWindow.vue'
import loadingModalWindow from './modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      option: require('../img/option.png'),
      escape: require('../img/escape.png'),
      logoutWord: 'ログアウトしますか？',
      failedWord: '',
      showExitModalWindow: false,
      showOptionModalWindow: false,
      showCompleteModal: false,
      showfailedModal: false,
      showloadingModal: false
    }
  },
  components: {
    optionModalWindow,
    exitModalWindow,
    finishModalWindow,
    loadingModalWindow
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    accountName() {
      return this.$store.state.masters.loginUser.adminUserName
    },
    browsingAccountFlg() {
      return this.$store.state.masters.browsingAccountFlg
    }
  },
  methods: {
    close(e) {
      if (this.$store.state.masters.ratesFlagMaster.showRatesFlag === false) {
        this.$router.push('/careRings')
      }
      this.showExitModalWindow = false
      this.showOptionModalWindow = false
      this.showCompleteModal = false
      this.showfailedModal = false
    },
    async showOptionWindow() {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('masters/setMaster')
        await this.$store.dispatch('masters/setStatus')
        this.showloadingModal = false

        this.showOptionModalWindow = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_430001
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header
        ) {
          let errorCode = error.response.data.header.errorCode.substring(0, 6)
          if (errorCode === 'CRB052') {
            this.completeWord =
              this.errorMsg.MSGCRC0086.name +
              this.errorMsg.MSGCRC0086.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorCode === 'CRB073') {
            eventNumber = this.$store.state.error.errorCode.errorCode_430010
            this.completeWord =
              this.errorMsg.MSGCRC0192.name +
              this.errorMsg.MSGCRC0192.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.completeWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showCompleteModal = true
        this.showloadingModal = false
      }
    },
    async logout(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('masters/logoutCareRings')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_500001
        let eventType = 9
        let reason = 'MSGCRC0005'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
      }
      this.showExitModalWindow = false
      this.$router.push('/Pages')
      this.showloadingModal = false
    }
  }
}
</script>
<style scope>
.menu_bottom {
  height: auto !important;
  min-height: 53px !important;
  display: flex;
  text-align: left;
  align-items: center;
}
.login_user_name {
  width: 50%;
  overflow-wrap: anywhere;
  padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/menubottom.vue